module.exports = __webpack_public_path__ + "img/ads.31664e62.png";